export default __webpack_public_path__ + "static/media/basis-unselected.64a47fd2.png";